import * as React from "react";
import {Helmet} from "react-helmet";
import HeroTextOnLeftBlock from "../layouts/hero-text-on-left-block/hero-text-on-left-block";
import TitleBlock from "../layouts/title-block/title-block";
import IntroStepSelectBlock from "../layouts/intro-step-select-block/intro-step-select-block";
import PricingTableBlock from "../layouts/pricing-table-block/pricing-table-block";
import ContactFormBlock from "../layouts/contact-form-block/contact-form-block";
import FaqBlock from "../layouts/faq-block/faq-block";
import {PageType} from "../models/types";
import {GoogleAnalyticsEventType} from "../models/google-analytics";
import * as staticImages from "../constants/static-images";
import * as initialFormData from "../constants/form-data";
import * as freshworksData from "../constants/freshworks-data";
import * as faqQuestionsData from "../constants/faq-questions-data";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";
import AchievementsCounterBlock from "../layouts/achievements-counter-block/achievements-counter-block";
import * as companyData from "../constants/company-data";

interface ZakladanieSpolekZooPageProps {
}

interface ZakladanieSpolekZooPageState {
}

class ZakladanieSpolekZooPage extends React.Component<ZakladanieSpolekZooPageProps, ZakladanieSpolekZooPageState> {

    componentDidMount() {
        cacheBustingService.handleCacheBusting(caches);
    }

    render() {
        return (
            <div>
                <Helmet {...helmetData.prepareHelmetData(PageType.ZakladanieSpolekZooPage)}/>

                <HeroTextOnLeftBlock
                    title={"Zakładanie spółek online"}
                    description={["Rejestrujemy spółki w całej Polsce."]}
                    backgroundImage={staticImages.BUSINESS_HANDSHAKE_BACKGROUND_IMAGE}
                    componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedMainTitleBlock}
                />

                <TitleBlock
                    firstLineBlackStart={"Załóż spółkę w"}
                    firstLineBlue={"3 krokach"}
                    firstLineBlackEnd={""}
                    secondLineText={"Zakładasz działalność i szukasz prostego sposobu na rejestrację spółki online? Z nami zrobisz to w 100% zdalnie bez zbędnych i niepotrzebnych formalności. Oferujemy zarówno kompleksową usługę rejestracji, jak i praktyczne materiały krok po kroku, które pozwolą Ci przeprowadzić proces samodzielnie."}
                    paddingBottom={0}
                />
                <IntroStepSelectBlock
                    stepSelectElements={[
                        {
                            elementSelectorTitle: "WYBÓR SPÓŁKI",
                            elementSelectorDescription: [
                                "Przedsiębiorcy najczęściej wybierają spółkę z o.o., ale dostępna jest jeszcze prosta spółka akcyjna. Podpowiemy, czym różnią się formy prowadzenia działalności i która najlepiej odpowiada Twoim potrzebom dzięki czemu podejmiesz świadomą decyzję.",
                            ]
                        },
                        {
                            elementSelectorTitle: "KONTAKT",
                            elementSelectorDescription: "Masz już pomysł, jaką spółkę chcesz założyć, albo nadal się wahasz? Po prostu skontaktuj się, odpowiemy na pytania, rozwiejemy wątpliwości i pomożemy przejść przez formalności bez stresu. Jesteśmy dostępni przez czat, telefon oraz formularz kontaktowy."
                        },
                        {
                            elementSelectorTitle: "REJESTRACJA SPÓŁKI",
                            elementSelectorDescription: "To już ostatni krok. Jeżeli zdecydowałeś się na naszą pomoc, przygotowujemy wszystkie wymagane dokumenty – umowę spółki, załączniki oraz wniosek do KRS. W zależności od wybranej ścieżki podpisujesz umowę elektronicznie przez system S24 albo u notariusza. Gdy tylko spółka zostanie wpisana do KRS, można zacząć działać."
                        }
                    ]}
                    componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedStepSelectBlock}
                    elementSelectEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooPageClickedStepSelectElement}
                />

                <TitleBlock
                    firstLineBlackStart={"Rejestrujemy "}
                    firstLineBlue={"Spółki"}
                    firstLineBlackEnd={"w całej Polsce"}
                    secondLineText={"Pomagamy zakładać spółki na terenie całej Polski – bez stresu, bez kolejek i bez zbędnego papieru. Działamy od lat i dobrze znamy realia sądowe czy urzędowe. Jeżeli natomiast chcesz założyć spółkę osobiście, to nasz poradnik to konkret – stworzony przez praktyków, którzy wiedzą, jak zarejestrować spółkę szybko."}
                />
                <AchievementsCounterBlock
                    counters={[
                        {
                            iconString: "watch",
                            counterStart: 0,
                            counterEnd: companyData.FAKTUROMANIA_YEARS_ON_MARET,
                            counterDuration: 3,
                            counterText: "LAT NA RYNKU"
                        },
                        {
                            iconString: "person",
                            counterStart: 0,
                            counterEnd: 600,
                            counterDuration: 5,
                            counterText: "ZAREJESTROWANYCH PRZEZ NAS SPÓŁEK"
                        },
                        {
                            iconString: "description",
                            counterStart: 0,
                            counterEnd: 14000,
                            counterDuration: 5,
                            counterText: "POBRAŃ PORADNIKA REJESTRACJI"
                        }
                    ]}
                    componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedAchievementsBlock}
                />

                <TitleBlock
                    firstLineBlackStart={"Przejrzyste zasady"}
                    firstLineBlue={"rejestracji spółki"}
                    firstLineBlackEnd={""}
                    secondLineText={"Bez względu na to, czy zdecydujesz się na usługę płatną, czy wybierzesz samodzielne działanie z naszym poradnikiem – proces rejestracji spółki będzie dla Ciebie jasny, bezpieczny i uporządkowany. W ramach usługi płatnej oferujemy indywidualne wsparcie i opiekę specjalisty. Jeśli działasz samodzielnie, otrzymasz od nas przejrzysty poradnik, który krok po kroku przeprowadzi Cię przez cały proces."}
                    paddingTop={20}
                />
                <PricingTableBlock
                    packagesInfo={
                        {
                            packageFeaturesTitle: "ZAŁÓŻ SPÓŁKĘ",
                            packageFeaturesSubtitle: "z o.o. lub p.s.a.",
                            packageFeatureColumnSize: 3,
                            packageFeatures: [
                                {
                                    featureName: "Forma działalności",
                                    featureHasTooltip: true,
                                    featureDescription: "Forma prawna rejestrowanej działalności gospodarczej."
                                },
                                {
                                    featureName: "Przygotowanie dokumentów",
                                    featureHasTooltip: true,
                                    featureDescription: "Przygotowanie umowy spółki wraz z załącznikami m.in. oświadczenia oraz listy."
                                },
                                {
                                    featureName: "Wsparcie merytoryczne",
                                    featureHasTooltip: true,
                                    featureDescription: "Kontakt telefoniczny, przez czat lub mailowy z ekspertem specjalizującym się w spółkach oraz podatkach."
                                },
                                {
                                    featureName: "Przygotowanie wniosku KRS",
                                    featureHasTooltip: true,
                                    featureDescription: "Obejmuje przygotowanie składanego do Sądu wniosku wraz z kompletem załączników."
                                },
                                {
                                    featureName: "Formularze skarbowe",
                                    featureHasTooltip: true,
                                    featureDescription: "Przygotowanie formularzy skarbowych wraz z wyliczeniem zobowiązania podatkowego tj. PCC-3, NIP-8 oraz VAT-R."
                                },
                                {
                                    featureName: "Czas rejestracji",
                                    featureHasTooltip: true,
                                    featureDescription: "Czyli czas potrzebny do przeprocesowania wniosku przez Sąd. Czas ten jest zależny od regionu Polski, w przypadku województwa mazowieckiego, pomorskiego oraz małopolskiego czas jest najdłuższy i może przekraczać nawet 2 tygodnie."
                                },
                                {
                                    featureName: "Koszty urzędowe",
                                    featureHasTooltip: true,
                                    featureDescription: "Są to koszty skarbowe lub podatku PCC od kapitału zakładowego, które nie są wliczone w cenę usługi."
                                },
                                {
                                    featureName: "Koszty dodatkowe",
                                    featureHasTooltip: true,
                                    featureDescription: "Są to koszty dodatkowe, które nie są wliczone w cenę usługi. W przypadku rejestracji S24 jest to opłata sądowa w kwocie 350,39zł. W przypadku rejestracji tradycyjnej koszty opłat sądowych wynoszą 600zł zaś notarialne są zależne od regionu Polski, najczęściej mieszczą się w widełkach od 400 do 800zł."
                                },
                                {
                                    featureName: "Opieka specjalisty",
                                    featureHasTooltip: true,
                                    featureDescription: "Proces rejestracji, przygotowania umowy spółki i wszystkich dokumentów przebiega pod opieką specjalisty albo Radcy Prawnego lub Adwokata."
                                },
                            ]
                        }
                    }
                    packages={[
                        {
                            packageFeatureColumnSize: 3,
                            packageName: "Rejestracja z poradnikiem",
                            packagePrice: '0',
                            packagePricingInfo: "ZŁ",
                            packagePricingNetInfoVisible: true,
                            packageIsFeatured: false,
                            packageIsCurrent: false,
                            packageFeatures: [
                                {
                                    featureType: "text",
                                    featureText: "z o.o.",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "text",
                                    featureText: "we własnym zakresie",
                                },
                                {
                                    featureType: "text",
                                    featureText: "w formie poradnika",
                                },
                                {
                                    featureType: "text",
                                    featureText: "we własnym zakresie",
                                },
                                {
                                    featureType: "text",
                                    featureText: "we własnym zakresie",
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 48h do 2 tygodni*",
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 23 zł",
                                },
                                {
                                    featureType: "text",
                                    featureText: "350,39 zł",
                                },
                                {
                                    featureType: "text",
                                    featureText: "we własnym zakresie",
                                }
                            ],
                            packageButtonHidden: false,
                            packageButtonText: "Wybieram",
                            packageButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000516839-rejestracja-sp%C3%B3%C5%82ki-z-o-o-krok-po-kroku-kompletny-przewodnik",
                            packageButtonLinkOpenNewTab: true,
                            packageButtonLinkIsForScrolling: true
                        },
                        {
                            packageFeatureColumnSize: 3,
                            packageName: "Rejestracja Fakturomania S24",
                            packagePrice: '970',
                            packagePricingInfo: "ZŁ",
                            packagePricingNetInfoVisible: true,
                            packageIsFeatured: true,
                            packageIsCurrent: true,
                            packageFeatures: [
                                {
                                    featureType: "text",
                                    featureText: "sp. z o.o. lub p.s.a.",
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 48h do 2 tygodni*",
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 23 zł",
                                },
                                {
                                    featureType: "text",
                                    featureText: "350,39 zł",
                                },
                                {
                                    featureType: "text",
                                    featureText: "wsparcie Eksperta",
                                }
                            ],
                            packageButtonHidden: false,
                            packageButtonText: "Wybieram",
                            packageButtonLinkTo: "#zakladanie-spolek-zoo",
                            packageButtonLinkIsForScrolling: true
                        },
                        {
                            packageFeatureColumnSize: 3,
                            packageName: "Rejestracja kancelaria",
                            packagePrice: '*',
                            packagePricingInfo: "Indywidualna wycena umowy spółki",
                            packageIsFeatured: false,
                            packageIsCurrent: false,
                            packageFeatures: [
                                {
                                    featureType: "text",
                                    featureText: "każda forma działalności",
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "icon",
                                    featureIncluded: true
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 48h do 2 tygodni*",
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 40 zł",
                                },
                                {
                                    featureType: "text",
                                    featureText: "od 1000 zł*",
                                },
                                {
                                    featureType: "text",
                                    featureText: "Adwokat lub Radca Prawny",
                                }
                            ],
                            packageButtonHidden: false,
                            packageButtonText: "Wybieram",
                            packageButtonLinkTo: "#zakladanie-spolek-zoo",
                            packageButtonLinkIsForScrolling: true
                        },
                    ]}
                    componentViewEventType={GoogleAnalyticsEventType.BiuroRachunkowePageViewedPricingTableBlock}
                    buttonClickEventType={GoogleAnalyticsEventType.BiuroRachunkowePageClickedCTAButtonAtPricingTableBlock}
                />

                <TitleBlock
                    firstLineBlackStart={"Zakładanie spółki -"}
                    firstLineBlue={"pytania i konkretne odpowiedzi"}
                    firstLineBlackEnd={""}
                    secondLineText={"Masz pytania o założenie spółki z o.o. albo prostej spółki akcyjnej? Kapitał zakładowy, kapitał akcyjny, wspólnicy, akcjonariusze, formularze albo księgowość? Znajdziesz tu odpowiedzi na najważniejsze pytania związane z rejestracją spółki z o.o. lub p.s.a. przez internet - od kosztów, przez formalności, do wpisu w KRS. Przejrzyście, konkretnie i bez prawniczego żargonu."}
                    paddingTop={100}
                />
                <FaqBlock
                    faqQuestions={faqQuestionsData.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS}
                    componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooViewedFaqBlock}
                    faqQuestionReadEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooReadFaqQuestion}
                />

                <TitleBlock
                    id={"zakladanie-spolek-zoo"}
                    firstLineBlackStart={"Potrzebujesz pomocy przy"}
                    firstLineBlue={"zakładaniu spółki"}
                    firstLineBlackEnd={"?"}
                    secondLineText={"Porozmawiaj z nami o rejestracji. Wiemy wszystko o spółkach z ograniczoną odpowiedzialnością, prostych spółkach akcyjnych, formalnościach lub księgowości. Doradzimy, podpowiemy i przeprowadzimy Cię przez każdy etap – od pomysłu po wpis w KRS."}
                    paddingTop={75}
                    paddingBottom={0}
                />
                <ContactFormBlock
                    formInfo={initialFormData.ZakladanieSpolekZooPageFormInfo}
                    iframeSourceUrl={freshworksData.ZAKLADANIE_SPOLEK_PAGE_FORM_IFRAME_SOURCE_URL}
                />

            </div>
        )
    }

}

export default ZakladanieSpolekZooPage


// WEBPACK FOOTER //
// ./src/pages/zakladanie-spolek-zoo.tsx